
const initState = {
 phoneEntered: false,
 timer:60,
 phoneNumber: '',
 information: {}
}

const loginReducer = (state = initState, action) =>{
  switch (action.type) {
    case 'NEXT_STEP' :
      return {...state, phoneEntered: action.payload}
    case 'COUNTER' :
      return {...state, timer: state.timer-1}
    case 'SET_PHONE' :
      return {...state, phoneNumber: action.payload}
    case 'SAVE' :
      return {...state, information: action.payload}
    case 'URI' :
      const newInfo = {...state.information, img_uri: action.payload}
      return {...state, information: newInfo}
    default:{
      return state;
    }
  }
}

export default loginReducer;
